var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about",staticStyle:{"padding-top":"30px"}},[_c('h1',[_vm._v("Session expired.")]),_c('br'),_c('span',[_vm._v("Please scan the QR code to submit questions or requests.")])])
}]

export { render, staticRenderFns }